export const COURSE_MEMBERSHIP_DATA_FETCH_START =
  'COURSE_MEMBERSHIP_DATA_FETCH_START';
export const COURSE_MEMBERSHIP_DATA_FETCH_SUCCESS =
  'COURSE_MEMBERSHIP_DATA_FETCH_SUCCESS';
export const COURSE_MEMBERSHIP_DATA_FETCH_FAILED =
  'COURSE_MEMBERSHIP_DATA_FETCH_FAILED';
